<template>
  <div class="des">
    <div class="des-con clearfix">
      <div class="des-left">
        <el-input v-model="text" type="textarea" :rows="14" placeholder="请输入DES / AES加密解密文本" />
      </div>
      <div class="des-right">
        <el-input v-model="result" type="textarea" :rows="14" placeholder="加密解密结果" />
      </div>
    </div>
    <div class="des-opa clearfix">
      <ul class="opa-opation clearfix">
        <el-radio-group v-model="type">
          <el-radio-button label="DES"></el-radio-button>
          <el-radio-button label="AES"></el-radio-button>
        </el-radio-group>
      </ul>
      <div class="opa-key clearfix">
        <el-button>秘钥</el-button>
        <el-input v-model="keyText" type="text" />
      </div>
      <div class="opa-key clearfix">
        <el-button>偏移量</el-button>
        <el-input v-model="iv" type="text" />
      </div>
      <ul class="opa-btn clearfix">
        <el-button type="primary" @click="encrypt">加密</el-button>
        <el-button type="primary" @click="decrypt">解密</el-button>
        <el-button @click="clear">清空</el-button>
      </ul>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
export default {
  data () {
    return {
      text: '',
      keyText: '',
      type: 'DES',
      result: '',
      iv: ''
    }
  },
  methods: {
    encrypt () {
      if (this.text == '') return
      const key = CryptoJS.enc.Utf8.parse(this.keyText)
      const iv = CryptoJS.enc.Utf8.parse(this.iv)
      if (this.type === 'DES') {
        this.result = CryptoJS.DES.encrypt(this.text, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }).toString()
      } else {
        this.result = CryptoJS.AES.encrypt(this.text, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }).toString()
      }
      
    },
    decrypt () {
      if (this.text === '') return
      const key = CryptoJS.enc.Utf8.parse(this.keyText)
      const iv = CryptoJS.enc.Utf8.parse(this.iv)
      if (this.type === 'DES') {
        this.result = CryptoJS.DES.decrypt(this.text, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }).toString(CryptoJS.enc.Utf8)
      } else {
        this.result = CryptoJS.AES.decrypt(this.text, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }).toString(CryptoJS.enc.Utf8)
      }
    },
    clear () {
      this.text = ''
      this.keyText = ''
      this.result = ''
      this.iv = ''
    }
  }
}
</script>

<style lang="stylus" scope>
.des
  .des-text
    padding-right 20px
    textarea
      width 100%
      padding 10px
      font-size 14px
      line-height 18px
      border 1px solid #eee
      border-radius 2px

.des-opa
  margin 22px 0 20px 0
  .opa-opation
    float left
    border-radius 4px
    border 1px solid #eee
    overflow hidden
    li
      float left
      line-height 36px
      color #333
      padding 0 10px
      cursor pointer
    .type
      background-color #1890ff
      color #fff


.opa-key
  margin-left 20px
  float left
  .el-input
    width 230px
    .el-input__inner
      border-radius 0 4px 4px 0
  .el-button
    border-right none
    border-radius 4px 0 0 4px

.opa-btn
  float left
  margin-left 20px
  border-radius 4px
  overflow hidden
  li
    float left
    line-height 36px
    font-size 14px
    padding 0 10px
    cursor pointer
    background-color #1890ff
    color #fff
  li:first-child
    border-right 1px solid rgba(0, 0, 0, .1)  
  li:last-child
    background-color #eee
    color #333
    border 1px solid #bbb
    border-left none
    line-height 34px
    border-radius 0 4px 4px 0

.des-con
  .des-left
    float left
    width 590px
  .des-right
    float right
    width 590px  
</style>